import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import productService from "./ProductService";
import InputField from "../../componentes/form-fields/InputField/InputField";
import DefaultChip from "../../componentes/chip/DefaultChip";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import ProductMotulImagesPanel from "./ProductMotulImagesPanel";

export default function ProductMotul() {
    const { t } = useTranslation();
    const { control } = useForm();

    const userId = sessionStorage.getItem("userId");
    const loggedIdClient = Number(sessionStorage.getItem("idClient") || 0);

    const initialProductState = {
        idProduct: 0,
        idClient: 8,
        productName: '',
        productCodeSKU: '',
        productCodeEAN: '',
        status: 1,
        userId: userId,
        tagging: 2,
        labelInformation: '',
    };


    const [product, setProduct] = useState(initialProductState);

    const { productName, productCodeSKU, productCodeEAN, idClient, status, tagging, labelInformation, idProduct } = product;

    const [clearedProduct, setClearedProduct] = useState(false);
    const [programRoleRows, setProductRows] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const columnsProduct = (t) => [
        {
            field: "idClient",
            textAlign: 'center',
            visible: false,
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="idCliente" name="" />;
            },
            template: (props) => {
                return (
                    <DefaultChip
                        style="standard"
                        label={
                            <Typography variant="body3" style={{ whiteSpace: 'normal' }}>
                                {props.idClient}
                            </Typography>
                        }
                    />
                );
            }
        },
        {
            field: "idProduct",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="ids" name="id" />;
            },
            template: (props) => {
                return (
                    <DefaultChip
                        style="standard"
                        label={
                            <Typography variant="body3" style={{ whiteSpace: 'normal' }}>
                                {props.idProduct}
                            </Typography>
                        }
                    />
                );
            }
        },
        {
            field: "productName",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="productName" name="productName" />;
            },
        },
        {
            field: "productCodeSKU",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="productCodeSKU" name="code" />;
            },
            template: (props) => {
                return (
                    <DefaultChip
                        style="grey"
                        label={
                            <Typography variant="body3" style={{ whiteSpace: 'normal' }}>
                                {props.productCodeSKU}
                            </Typography>
                        }
                    />
                );
            }
        },
        {
            field: "productCodeEAN",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="productCodeEAN" name="code" />;
            },
            template: (props) => {
                return (
                    <DefaultChip
                        style="grey"
                        label={
                            <Typography variant="body3" style={{ whiteSpace: 'normal' }}>
                                {props.productCodeEAN}
                            </Typography>
                        }
                    />
                );
            }
        },
        {
            field: "tagging",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="toLabel" name="tag" />;
            },
            template: (props) => {
                const isTagging = props.tagging === 1;

                return (
                    <DefaultChip
                        style={isTagging ? "success" : "standard"}
                        label={
                            <Typography variant="body3" style={{ whiteSpace: 'normal' }}>
                                {isTagging ? "Sim" : "Não"}
                            </Typography>
                        }
                    />
                );
            }
        },
        {
            field: "labelInformation",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="labelInformation" name="info" />;
            },
            template: (props) => {
                const isTagging = props.tagging === 1;
                const labelInfo = props.labelInformation || "";
                const shortLabelInfo = labelInfo.length > 25
                    ? `${labelInfo.substring(0, 25)}...`
                    : labelInfo;

                return (
                    <Typography
                        variant="body3"
                        style={{
                            whiteSpace: 'normal',
                            cursor: isTagging && labelInfo ? 'pointer' : 'default',
                            textDecoration: isTagging && labelInfo ? 'underline' : 'none'
                        }}
                        onClick={() => {
                            if (isTagging && labelInfo) {
                                handleOpenLabelInfo(labelInfo);
                            }
                        }}
                    >
                        {isTagging ? shortLabelInfo : "-"}
                    </Typography>
                );
            }
        },
        {
            field: "status",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="statusCode" name="status" />;
            },
            template: (props) => {
                return (
                    <>
                        {props.status ? (
                            <IconSwitch name="active" />
                        ) : (
                            <IconSwitch name="canceled" />
                        )}
                    </>
                );
            },
        }
    ];

    const [openLabelInfo, setOpenLabelInfo] = useState(false);
    const [selectedLabelInfo, setSelectedLabelInfo] = useState("");

    const handleOpenLabelInfo = (info) => {
        setSelectedLabelInfo(info);
        setOpenLabelInfo(true);
    };

    const handleCloseLabelInfo = () => {
        setOpenLabelInfo(false);
        setSelectedLabelInfo("");
    };


    const handleChange = (event) => {
        const { name, value } = event.target;
        setProduct({ ...product, [name]: value });
    };

    const handleChangeTagging = (event) => {
        const { checked } = event.target;

        setProduct({
            ...product,
            tagging: checked,
            labelInformation: checked ? product.labelInformation : ''
        });
    };

    const handleCloseAlertProduct = () => {
        setProduct({ ...product });
        setError(false);
        setSuccess(false);
    };

    const handleClearProduct = () => {
        setClearedProduct(!clearedProduct);
        setProduct(initialProductState);
        setProductRows([]);
        setError(false);
        setSuccess(false);
    };

    const handleSearchProduct = () => {
        let request = {
            ...product
        }

        productService
            .getProductMotul(request)
            .then((response) => {
                setProductRows(response.data)
            })
            .catch((e) => {
                setMessage(t("noDataFound"));
                setError(true);
                setProductRows([]);
            });
    };

    const canSaveProduct = () => {
        if (!productName || !productCodeSKU || !productCodeEAN || !idClient) {
            setError(true);
            setMessage(t("fillRequiredFields"));
            return false;
        } else if (status === 0) {
            console.log("status cancelado", status);
            setError(true);
            setMessage(t("errorCannotRegisterCancelledProduct"));
            return false;
        }

        setError(true);
        if (!productName || !productCodeSKU || !productCodeEAN || !idClient || tagging === 2) {
            setMessage(t("selectLabeling"));
            return false;
        }

        setError(false);
        return true;
    };

    const handleSaveProduct = () => {
        let request = { ...product, userId: userId };

        if (request.idProduct <= 0) {
            if (!canSaveProduct()) {
                return;
            }
        }

        setMessage("");
        setSuccess(false);
        setProduct({ ...product, warningProduct: false });
        productService
            .createProductMotul(request)
            .then((response) => {
                setProduct((current) => ({ ...current, idProduct: response?.data?.idProduct || current.idProduct }));
                setMessage(t("saveSuccess"));
                setSuccess(true);
                handleSearchProduct();
            })
            .catch((e) => {
                setMessage(t("saveError"));
            });
    };

    const handleClickGrid = (rowData) => {
        setMessage("");
        setSuccess(false);

        setProduct({
            idProduct: rowData.idProduct,
            idClient: rowData.idClient,
            productName: rowData.productName,
            productCodeSKU: rowData.productCodeSKU,
            productCodeEAN: rowData.productCodeEAN,
            tagging: rowData.tagging,
            labelInformation: rowData.labelInformation,
            status: rowData.status
        });
    };

    useEffect(() => {
        handleSearchProduct();
    }, [])

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="product"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                error={error}
                                success={success}
                                message={message}
                                handleCloseAlert={handleCloseAlertProduct}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={3} md={3}>
                                    <div style={{
                                        pointerEvents: "none",
                                        opacity: 0.8
                                    }}>
                                        <DefaultAutocomplete
                                            iconLabelSwitch={
                                                <IconLabelSwitch
                                                    name="unLock"
                                                    labelName="client"
                                                />
                                            }
                                            name="idClient"
                                            disabled={true}
                                            value={idClient}
                                            defaultSize
                                            useApi
                                            endpoint='GetClient'
                                            error={error && idClient === 0}

                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="productName" />
                                        }
                                        name="productName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={productName}
                                        length={50}
                                        error={error && productName === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="code" labelName="productCodeSKU" />
                                        }
                                        name="productCodeSKU"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={productCodeSKU}
                                        length={30}
                                        error={error && productCodeSKU === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="code" labelName="productCodeEAN" />
                                        }
                                        name="productCodeEAN"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={productCodeEAN}
                                        length={30}
                                        error={error && productCodeEAN === ""}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="tag" labelName="toLabel" />
                                        }
                                        name="tagging"
                                        onChange={handleChange}
                                        value={tagging}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("no"), status: 1 },
                                            { id: 1, name: t("yes"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                        error={error && tagging === 2}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                        error={error && status === 2}
                                    />
                                </Grid>

                                {tagging === 1 && (
                                    <Grid item xs={12} sm={12} md={12}>
                                        <InputField
                                            iconLabelSwitch={
                                                <IconLabelSwitch name="description" labelName="labelInformation" />
                                            }
                                            name="labelInformation"
                                            control={control}
                                            defaultValue=""
                                            onChange={handleChange}
                                            value={labelInformation}
                                            multiline
                                            rows={4}
                                            length={500}
                                        />
                                    </Grid>
                                )}

                            </GridInputRow>
                            <SearchClearSaveRow
                                onClickClear={handleClearProduct}
                                onClickSearch={handleSearchProduct}
                                onClickSave={handleSaveProduct}
                            />

                            {(loggedIdClient === 0 || loggedIdClient === 8) ? (
                                <ProductMotulImagesPanel
                                    productId={idProduct}
                                    canEdit={status !== 0}
                                />
                            ) : null}

                        </GridItemContainer>

                        <Dialog open={openLabelInfo} onClose={handleCloseLabelInfo} maxWidth="sm" fullWidth>
                            <DialogTitle>Informações da etiqueta</DialogTitle>

                            <DialogContent>
                                <Typography variant="body2" style={{ whiteSpace: 'pre-wrap' }}>
                                    {selectedLabelInfo}
                                </Typography>
                            </DialogContent>

                            <DialogActions>
                                <Button onClick={handleCloseLabelInfo}>
                                    Fechar
                                </Button>
                            </DialogActions>
                        </Dialog>

                    </>
                }
            />
            {programRoleRows.length > 0 ? (
                <DefaultScreenAccordion

                    fields={
                        <DefaultDatagrid
                            columns={columnsProduct(t, handleSearchProduct)}
                            dataSource={programRoleRows}
                            cellSelected={(args, grid) => handleClickGrid(args.data)}
                            allowPaging={true}
                        />
                    } />
            ) : null}
        </>
    );
};
